import type { Modal } from '@ps/web-core-store';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useNavigate from '@swf/core/hooks/useNavigate';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import { FirstLoader } from '@swf/first';

import { TXTWCL_Loading_cashier } from './FirstAuthLoadingPage.messages.json';

const FirstAuthLoadingPage: React.FC = () => {
  const hasClientSession = useSelector(select.session.hasClientSession);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { modal } = useDispatch<Dispatch>();
  const { path } = (useSelector(select.modal.getCurrent) || {}) as Partial<Modal>;
  const loginModalOpened = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      return;
    }
    if (path === '/auth/login') {
      loginModalOpened.current = true;
    }
    if (loginModalOpened.current === true && path !== '/auth/login') {
      navigate('/'); // go lobby when login dialog dismissed
    }
  }, [path, isAuthenticated, loginModalOpened, navigate]);

  useEffect(() => {
    if (hasClientSession && !isAuthenticated) {
      modal.enqueue({ path: '/auth/login' });
    }
  }, [isAuthenticated, hasClientSession, modal]);

  return <FirstLoader label={TXTWCL_Loading_cashier} />;
};

export default FirstAuthLoadingPage;
